/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSIGNATORYROLE = {
    Policyholder: '1',
    Spouse: '2',
    Guardian: '3',
    Parent: '4',
    PowerOfAttorney: '5',
    ThirdParty: '6',
    Intermediary: '7',
    Other: '8',
    AuthorisedIndividual: '9',
    Curator: '10',
    BankAccountHolder: '11'
} as const;
export type IAPSIGNATORYROLE = typeof IAPSIGNATORYROLE[keyof typeof IAPSIGNATORYROLE];


export function IAPSIGNATORYROLEFromJSON(json: any): IAPSIGNATORYROLE {
    return IAPSIGNATORYROLEFromJSONTyped(json, false);
}

export function IAPSIGNATORYROLEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSIGNATORYROLE {
    return json as IAPSIGNATORYROLE;
}

export function IAPSIGNATORYROLEToJSON(value?: IAPSIGNATORYROLE | null): any {
    return value as any;
}

